module.exports = __webpack_public_path__ + "media/images/sp/stores/fuji/fuji_sns_05-f1838fdcc6f67b438fa16b96819add33.jpg";